import { Mutation, Role, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { generateMockVisitorGroupMembership } from 'mocks/graphqlMocks/visitorGroupMembership';

export function mockedUpdateVisitorGroupData(updateVisitorGroup: VisitorGroup): Pick<Mutation, 'updateVisitorGroup'> {
  return {
    updateVisitorGroup
  };
}

export const mockedUpdateVisitorGroupDataForMutation = mockedUpdateVisitorGroupData(
  generateMockVisitorGroup({
    id: 'mockedVisitorGroupIdExternalUsers1',
    name: 'co-contractors1-new',
    maxNumberOfMembers: 3,
    members: [
      generateMockVisitor({
        id: 'mockedVisitorIdExternalUser1',
        name: 'mockedVisitorNameExternalUser1',
        email: 'mockedVisitorEmailExternalUser1',
        mobileDevices: [],
        visitorGroupMembership: [
          generateMockVisitorGroupMembership({
            visitorGroup: generateMockVisitorGroup({ id: 'mockedVisitorGroupIdExternalUsers1' }),
            role: Role.ExternalGroupUser
          })
        ]
      }),
      generateMockVisitor({
        id: 'mockedVisitorIdExternalUser2',
        name: 'mockedVisitorNameExternalUser2',
        email: 'mockedVisitorEmailExternalUser2',
        mobileDevices: [
          {
            __typename: 'MobileDevice',
            id: 'mockedMobileDevice',
            isRegistered: true,
            registrationDate: null,
            registrationToken: null,
            role: 'ACCESS'
          }
        ],
        visitorGroupMembership: [
          generateMockVisitorGroupMembership({
            visitorGroup: generateMockVisitorGroup({ id: 'mockedVisitorGroupIdExternalUsers1' }),
            role: Role.ExternalGroupUser
          })
        ]
      })
    ]
  })
);
